import AppearanceForm from "../Components/AppearanceForm";
import MelhousPage from "../Components/MelhousPage";
import { VIEW_APPEARANCE } from "../constants";

function MelhousAppearance() {
  return (
    <MelhousPage view={VIEW_APPEARANCE}>
      <div className="p-3 lg:p-4">
        <AppearanceForm />
      </div>
    </MelhousPage>
  );
}

export default MelhousAppearance;
